module.exports = __webpack_public_path__ + "static/img/tab1-area1-1.40bd319.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/tab1-area1-1.png
// module id = 640
// module chunks = 12